var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialwifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5ZM12.1725 9.85999C14.1261 9.85999 15.9049 10.6045 17.2554 11.8171L18.3947 10.6778C16.8025 9.085 14.6025 8.09999 12.1725 8.09999C9.74251 8.09999 7.54251 9.085 5.94971 10.6772L7.08901 11.8165C8.44011 10.6045 10.2189 9.85999 12.1725 9.85999ZM9.99702 14.7246L12.1724 16.9L14.3477 14.7246C13.7482 14.2518 12.9937 13.9666 12.1724 13.9666C11.351 13.9666 10.5966 14.2518 9.99702 14.7246ZM7.91846 12.6461L9.16219 13.8898C9.97824 13.2063 11.0278 12.7933 12.1724 12.7933C13.317 12.7933 14.3665 13.2063 15.182 13.8904L16.4257 12.6466C15.2887 11.6458 13.8027 11.0333 12.1724 11.0333C10.542 11.0333 9.056 11.6458 7.91846 12.6461Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialwifi);
export default __webpack_public_path__ + "static/media/Social wifi.0dc01d24af10c74066783283a0852896.svg";
export { ForwardRef as ReactComponent };